<div
  [ngClass]="{
    'calendar-field': true,
    'calendar-field--auto-validate': control,
    'calendar-field--valid': valid,
    'calendar-field--invalid': invalid,
    'calendar-field--disabled': disabled,
  }"
>
  @if (label) {
    <label class="form-label" [htmlFor]="id">{{ label }}</label>
  }

  <div class="form-control-container">
    <p-datepicker
      [(ngModel)]="rangeDates"
      lang="pt-br"
      [placeholder]="placeholder"
      selectionMode="range"
      [readonlyInput]="true"
      class="w-full"
    />
  </div>

  @if (control && control.errors && control.touched) {
    <cx-form-errors [control]="control" />
  } @else if (hintText) {
    <span class="form-hint-text">{{ hintText }}</span>
  }
</div>
